module.exports = __webpack_public_path__ + "media/Loops 90 Drums.14d0abdc.wav";